import $ from "jquery";

const register = () => {
  const init = () => {
    popup();
    validationFields();
  };

  const validationFields = () => {
    const el = {
      form: ".mi-Form--Register",
      input: ".mi-Form__Input",
      inputEmail: ".mi-Form__Input--email",
      inputAchternaam: ".mi-Form__Input--achternaam",
      inputVoornaam: ".mi-Form__Input--voornaam",
      inputDate: ".mi-Form__Input--date",
      inputBuildings: ".mi-Form__Input--buildings",
    };

    $(el.input).removeClass("mi-Form__Input--error");

    $(el.form).on("submit", function (e) {
      e.preventDefault();
      $(".mi-Form__Input").each(function () {
        if ($(this).val() === "") {
          $(this).addClass("mi-Form__Input--error");
          $(this).siblings(".js-ErrorMessage").html("Veld kan niet leeg zijn.");
          $(this).siblings(".js-ErrorMessage").show();
        } else {
          $(this).removeClass("mi-Form__Input--error");
          $(this).siblings(".js-ErrorMessage").hide();
        }
      });
    });
  };

  const popup = () => {
    const el = {
      form: ".mi-Form--Register",
      input: ".mi-Form__Input",
      inputEmail: ".mi-Form__Input--email",
      inputAchternaam: ".mi-Form__Input--achternaam",
      inputVoornaam: ".mi-Form__Input--voornaam",
      inputDate: ".mi-Form__Input--date",
      inputBuildings: ".mi-Form__Input--buildings",
      messageError: ".js-ErrorMessage",
      button: ".js-Form--Register__Button",
      popup: ".mi-RegisterPopup",
      closeButton: ".js-RegisterPopup__Close",
      popupMessage: '.mi-Popup__CloseChapter_Container '
    };

    $(el.closeButton).on("click", function (e) {
      e.preventDefault();
      $(el.popup).fadeOut();
    });

    $(el.button).on("click", function () {
      // e.preventDefault();
      $(el.popupMessage).css('display', 'block');
      let formData = {
        email: $("#email").val(),
        voornaam: $("#voornaam").val(),
        achternaam: $("#achternaam").val(),
        date: $("#date").val(),
        woonplaats: $("#woonplaats").val(),
      };

      // AJAX FORM
      if (
        $(el.input).val() !== "" &&
        $(el.inputEmail).val() !== "" &&
        $(el.inputText).val() !== "" &&
        $(el.inputDate).val() !== "" &&
        $(el.inputBuildings).val() !== ""
      ) {
        $.ajax({
          type: "POST",
          // eslint-disable-next-line no-undef
          url: themeParams.ajaxUrl,
          data: {
            action: "process_registration",
            form_data: formData,
          },
          success: function (response) {
            // console.log("halo : ", response['data']['status']);
            if (response["data"]["status"] == "200") {
              $(el.popup).fadeIn();
            } else {
              $(".js-RegisterPopup--Image").hide();
              $(".js-RegisterPopup--Title").text("Foutregistratie");
              $(".js-RegisterPopup--Desc").text(response["data"]["message"]);
              $(".js-RegisterPopup--Button a")
                .text("Sluit")
                .on("click", function (e) {
                  e.preventDefault();
                  $(el.popup).fadeOut();
                });
              $(el.popup).fadeIn();
            }
          },
          error: function () {
            $(".js-RegisterPopup--Image").hide();
            $(".js-RegisterPopup--Title").text("Foutregistratie");
            $(".js-RegisterPopup--Desc").text(
              "De e-mail/gebruikersnaam die u opgeeft is al geregistreerd"
            );
            $(".js-RegisterPopup--Button a")
              .text("Sluit")
              .on("click", function (e) {
                e.preventDefault();
                $(el.popup).fadeOut();
              });
              $(el.popup).fadeIn();
          },
        });
      }
    });
  };

  init();
};

try {
  register();
} catch (error) {
  // eslint-disable-next-line no-console
  console.log(error);
}
